<script lang="ts">
    import {createEventDispatcher} from "svelte";
    import Dialog, {Actions, Content} from "@smui/dialog";
    import NauiButton from "../naui/atoms/NauiButton.svelte";

    export let favorite: boolean = false;
    export let data: any;
    export let iconFav: string;
    export let iconAdd: string;
    export let iconShare: string;
    export let dialog: any = {
        open: false,
        message: ''
    }
    export let openShare = false;
    const dispatch = createEventDispatcher();

    function handleFav() {
        dispatch('update', data);
    }

    export function showDialog(message: string) {
        dialog = {
            message,
            open: true
        }
    }
</script>
<div class="box-r sx-1">
    <div style="cursor: pointer;">
        <img height="40" width="40" src="{iconShare}" on:click={()=>openShare=true} alt="Share">
        <!--div style="">
            <amp-social-share height="40" width="40" type="whatsapp"></amp-social-share>
        </div-->
    </div>
    <div style="cursor: pointer" id="data-fav" on:click={()=>handleFav()}>
        {#if favorite}
            <img height="40" width="40" src="{iconFav}" alt="Remover de favoritos">
        {:else}
            <img height="40" width="40" src="{iconAdd}" alt="Agregar a favoritos">
        {/if}
    </div>
</div>

<Dialog bind:open={dialog.open}
        scrimClickAction=""
        escapeKeyAction=""
        aria-describedby="mandatory-content">
    <Content id="mandatory-content">
        {dialog.message}
    </Content>
    <Actions>
        <div class="box sx-1 w-100">
            <NauiButton caption="INICIAR SESIÓN"
                        color="accent"
                        mode="solid"
                        href="/iniciar-sesion"/>
            <NauiButton caption="CANCELAR"
                        mode="solid"
                        on:click={() => {dialog.open = false;}}/>
        </div>
    </Actions>
</Dialog>

<Dialog bind:open={openShare}
        aria-describedby="simple-content">
    <Content id="simple-content">
        {#if openShare}
            <div class="box sx-ii">
                <amp-social-share height="40" width="40" type="twitter">
                </amp-social-share>
                <amp-social-share height="40" width="40" type="facebook">
                </amp-social-share>
                <amp-social-share height="40" width="40" type="whatsapp">
                </amp-social-share>
            </div>
        {/if}
    </Content>
</Dialog>